import { Grid, Typography, Switch } from '@mui/material';

interface IToggleFieldProps {
  value: boolean;
  handleChange: (value: boolean) => void;
  label: {
    toggle1: string;
    toggle2: string;
  };
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  isDisabled?: boolean;
}

export default function ToggleFieldControl({
  handleChange,
  label = {
    toggle1: '',
    toggle2: ''
  },
  value = true,
  isDisabled = false,
  error = ''
}: IToggleFieldProps) {
  return (
    <>
      <Grid container alignItems='center'>
        <Typography
          fontSize={12}
          fontWeight={!value ? 700 : 400}
          color={!value ? 'primary' : 'black'}
        >
          {label.toggle1}
        </Typography>
        <Switch
          checked={value}
          onChange={(_, checked) => handleChange(checked)}
          disabled={isDisabled}
          disableRipple
        />
        <Typography
          fontSize={12}
          fontWeight={value ? 700 : 400}
          color={value ? 'primary' : 'black'}
        >
          {label.toggle2}
        </Typography>
      </Grid>
      {error ? (
        <Typography fontSize='8px' color='red'>
          {error}
        </Typography>
      ) : null}
    </>
  );
}
